<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { open } from '../OverpanelControl/OverpanelControl.svelte';
  
  let {
    brandSwitchLabel,
    genericSwitchLabel,
    brandPriceTemplate,
    genericPriceTemplate,
    price = '',
    type = 'generic',
    dataTestId = 'pricing-drug-type-control',
    closeCallback = () => {},
  } = $props();

  let drugTypeControl = $state();

  const handleClick = () => {
    open('drugSelection', {
      closeCallback: () => {
        closeCallback();
        drugTypeControl.focus();
      },
    });
  };
</script>

<button
  class="w-full px-4 py-3 flex flex-col justify-center text-blue-cerulean active:text-blue-darkish focus:relative focus:outline-none
  active:shadow-inset-active focus:shadow-inset-focus hover-hover:hover:text-blue-darkish md:hover-hover:hover:bg-blue-very-light md:rounded-lg md:min-h-14 md:px-3 md:py-2 md:mt-4
  md:bg-white md:border md:border-gray-light-silver md:shadow-y-sm"
  data-testid={dataTestId}
  bind:this={drugTypeControl}
  onclick={handleClick}
>
  <div class="flex items-center">
    <svg class="stroke-current h-6 w-6 lg:h-10 lg:w-10 mr-4" role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#switch" />
    </svg>
    <div class="w-full flex flex-col text-left justify-between text-sm leading-normal">
      <span class="font-medium text-sm leading-5 md:text-base" data-testid="{dataTestId}-main-cta-label">
        {#if type === 'generic'}
          {brandSwitchLabel}
        {:else}
          <!-- prettier-ignore -->
          {genericSwitchLabel}
        {/if}
      </span>
      {#if price}
        <p class="text-gray-charcoal text-left text-sm" data-testid="{dataTestId}-subtext-label">
          {#if type === 'generic'}
            {brandPriceTemplate.replace(/{{PRICE}}/, `$${price}`)}
          {:else}
            <!-- prettier-ignore -->
            {genericPriceTemplate.replace(/{{PRICE}}/, `$${price}`)}
          {/if}
        </p>
      {/if}
    </div>
  </div>
</button>
